import { ChangeEvent, FC, useRef, useId, useState } from 'react';
import { Button } from '@marriott/mi-ui-library';
import { FileUploadProps } from './FileUpload.types';
import { TextFormField } from '../../../molecules/TextFormField';

export const FileUpload: FC<FileUploadProps> = ({
  fieldLabel,
  fieldAriaLabel,
  inputClass,
  ctaLabel,
  ctaClass,
  allowedFileTypes,
  fileFormatError = '',
  maxSize,
  fileSizeError = '',
  error,
  setError,
  onFileUpload,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const inputId = useId();

  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const validateFile = (file: File): boolean => {
    let errorFlag = false;
    if (maxSize) {
      if (file.size >= maxSize) {
        errorFlag = true;
        setError?.(fileSizeError);
      }
    }
    if (allowedFileTypes) {
      const fileType = file.name.split('.').pop();
      if (!fileType || !allowedFileTypes.includes(`.${fileType.toLowerCase()}`)) {
        errorFlag = true;
        setError?.(fileFormatError);
      }
    }

    return !errorFlag;
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (validateFile(file)) {
        setSelectedFile(file);
        setError?.('');
        onFileUpload(file);
      } else {
        setSelectedFile(null);
        onFileUpload(null);
      }
    }
  };

  const handleFileUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      fileInputRef.current.click();
    }
  };

  return (
    <>
      <label htmlFor={inputId} className="sr-only d-none">
        {fieldAriaLabel}
      </label>
      <input
        type="file"
        id={inputId}
        ref={fileInputRef}
        className="d-none"
        {...(allowedFileTypes && { accept: allowedFileTypes.join(', ') })}
        data-testid="file-input"
        onChange={handleFileChange}
      />
      <div className={inputClass}>
        <TextFormField
          label={fieldLabel}
          className="m-input-field"
          disabled={true}
          value={selectedFile ? selectedFile.name : ''}
          showErrorMessage={!!error}
          errorMessage={error || ''}
        />
      </div>
      <div className={ctaClass}>
        <Button buttonCopy={ctaLabel} className="py-2 m-button-primary" callback={handleFileUpload} />
      </div>
    </>
  );
};
